// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-3157b0b0]{fill:var(--v-grey4-base)}.cls-2[data-v-3157b0b0]{fill:var(--v-grey2-base)}", ""]);
// Exports
module.exports = exports;
